import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import StepperComponent from './FinancialModel/Stepper';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} direction="up" {...props} />;
});

const useStyles = makeStyles((theme) => ({
  container: {
    backdropFilter: 'blur(5px)'
  },
  header: {
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#132533'
  },
  paper: {
    padding: 30,
    minWidth: '80%'
  },
  textField: {
    marginTop: '.5rem',
    width: '100%'
  },
  buttonDiv: {
    marginTop: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    marginRight: 25,
    minWidth: '110px'
  },
  cancel: {
    background: '#6D7278',
    fontFamily: 'PT sans',
    fontSize: '16px',
    color: '#FFF',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    marginLeft: 25,
    minWidth: '110px'
  }
}));

const AmendModal = ({ open, onClose }) => {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        keepMounted
        classes={{ paper: classes.paper, container: classes.container }}
        maxWidth={false}
        open={open}
        TransitionComponent={Transition}
        onClose={onClose}>
        {/* Header */}
        <Typography gutterBottom className={classes.header} variant="h2">
          Amend order
        </Typography>
        <DialogContent>
          <StepperComponent sendOrder={onClose} saveOrder={onClose} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

AmendModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default AmendModal;
